var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocateTickets({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2064B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,1.4H1.5C1,1.4,0.6,1.8,0.6,2.3l0,0v15.4h13.6V2.3C14.2,1.8,13.8,1.4,13.3,1.4z M11.3,5.5 c-0.5,0.1-1,0.1-1.4,0.2C9.6,5,9.3,4.4,8.9,3.8C9.9,4.1,10.7,4.7,11.3,5.5z M8.9,9.8c-1-0.1-2-0.1-3,0C5.7,8.9,5.7,8,5.9,7.1 c1,0.1,2,0.1,3,0C9.1,8,9.1,8.9,8.9,9.8z M7.4,3.9c0.4,0.6,0.8,1.2,1.1,1.8c-0.7,0-1.4,0-2.1,0C6.6,5.1,7,4.5,7.4,3.9L7.4,3.9z  M5.9,3.8C5.5,4.4,5.2,5,4.9,5.7c-0.5,0-1-0.1-1.4-0.2C4.1,4.7,4.9,4.1,5.9,3.8L5.9,3.8z M2.5,8.5c0-0.6,0.1-1.2,0.3-1.7 C3.4,6.8,4,6.9,4.5,7c-0.2,1-0.2,2,0,3C4,10,3.4,10.1,2.8,10.2C2.6,9.6,2.5,9,2.5,8.5z M3.5,11.4c0.5-0.1,1-0.1,1.4-0.2 c0.3,0.7,0.6,1.3,1,1.9C4.9,12.8,4.1,12.2,3.5,11.4z M7.4,13c-0.4-0.6-0.8-1.2-1.1-1.8c0.7,0,1.4,0,2.1,0C8.2,11.8,7.8,12.4,7.4,13 L7.4,13z M8.9,13.2c0.4-0.6,0.7-1.2,1-1.9c0.5,0,1,0.1,1.4,0.2C10.7,12.2,9.9,12.8,8.9,13.2L8.9,13.2z M12,10.2 c-0.6-0.1-1.2-0.2-1.7-0.2c0.2-1,0.2-2,0-3c0.6-0.1,1.2-0.1,1.7-0.2C12.4,7.9,12.4,9.1,12,10.2L12,10.2z M0.6,20.7 c0,0.5,0.4,0.9,0.9,0.9h11.9c0.5,0,0.9-0.4,0.9-0.9v-1.2H0.6V20.7z M22,12.6c-0.6-0.1-1.1-0.6-1.2-1.2c0-0.2-0.2-0.4-0.4-0.4h-4.6 v2.7h2c0.4,0,0.8,0.3,0.8,0.8c0,0.4-0.3,0.8-0.8,0.8h-2v2h2c0.4,0,0.8,0.3,0.8,0.8c0,0.4-0.3,0.8-0.8,0.8h-2v1.9 c0,0.3-0.1,0.6-0.2,0.9h4.8c0.2,0,0.4-0.2,0.4-0.4c0.1-0.6,0.6-1.1,1.2-1.2c0.2,0,0.4-0.2,0.4-0.4v-6.5 C22.4,12.9,22.2,12.7,22,12.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocateTickets);
export default __webpack_public_path__ + "static/media/locate-tickets.09f6023fab69396b30c83c4ba6c0cc5f.svg";
export { ForwardRef as ReactComponent };